import React, {useState} from 'react'
import {Form, Button} from "react-bootstrap";
import axios from 'axios';
import {useTranslation} from "react-i18next";
import './Login.css'

function Login(){
    const [errorInfo, setErrorInfo] = useState(<div></div>);
    const [isAstra, setIsAstra] = useState(process.env.REACT_APP_SERVICE == 'astra');

    const { t } = useTranslation(['login', 'base']);

    function submitForm(event){
        event.preventDefault()
        console.log(event.target[0].value)
        console.log(event.target[1].value)

        axios.post('api/user/login', { login: event.target[0].value, password: event.target[1].value})
            .then(response => {window.location = "/"})
            .catch((error) => {setErrorInfo(<div style={{color: "red", paddingTop: "10px"}}>{t('login_incorrect')}</div>)});
    }

    return(
            <div className='login'>
                <div className='login-container'>
                    { isAstra ? <div className='console-logo'><img className='astra-icon' src="/image/astra/astra_logo.svg"/></div> : <div className='console-logo'>Air-link Console</div>}
                    <Form onSubmit={submitForm}>
                        <Form.Group className="login-form" controlId="formBasicEmail">
                            <Form.Label>{t('address')}</Form.Label>
                            <Form.Control type="email" placeholder={t('address_placeholder')} />
                            <Form.Text className="text-muted">
                            {/*We'll never share your email with anyone else.*/}
                            </Form.Text>
                        </Form.Group>

                        <Form.Group className="login-form" controlId="formBasicPassword">
                            <Form.Label>{t('password')}</Form.Label>
                            <Form.Control type="password" placeholder={t('password_placeholder')} />
                        </Form.Group>
                        <div className='login-buttons'>
                            <Button variant="primary" type="submit">
                                {t('Enter', { ns: "base"})}
                            </Button>
                            <Button variant="light" href='/registration'>
                                {t('Register', { ns: "base"})}
                            </Button>
                        </div>
                    </Form>
                    <div style={{marginTop: "10px"}}>
                        <a className='forgot-pass' href='/forgot-pass'>{t('forgot_pass')+ " "}</a>
                        {isAstra && <a className='forgot-pass' href='https://csky.space/astra_luckfox' target="_blank">{t('buy_a_set')}</a>}
                    </div>
                    {errorInfo}
                </div>
            </div>
    )
}

export default Login;
